module.exports = __webpack_public_path__ + "img/20200905_140649.adf9b226.jpg";